import React from "react";
import { useNavigate } from "react-router-dom";
const emptyScreenImage =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/emptyscreen.svg";
export default function EmptyScreen() {
  const navigate = useNavigate();
  return (
    <div className="emptyscreen">
      <img src={emptyScreenImage} alt="Empty Screen" />
      <h3>Our dashboard is waiting for action!</h3>
      <p>
        Get started by selecting a tool to dive into your medical practice and
        research.
      </p>
      <button
        className="elementselector"
        onClick={() => navigate("/dashboard")}
      >
        Home
      </button>
    </div>
  );
}
